import ReactGA from "react-ga";

function logParams(method_name, params) {
	console.log("GA " + method_name, params);
}
let methods = [
	"pageview",
	"set",
	"modalview",
	"event",
	"timing",
	"ga",
	"outboundLink",
	"exception",
];

let Analytics;
// We only want analytics to run in production
if (process.env.NODE_ENV === "production") {
	ReactGA.initialize("UA-42931319-1");
	Analytics = ReactGA;
} else {
	Analytics = {};
	methods.forEach((method_name) => {
		Analytics[method_name] = function() {
			logParams(method_name, [...arguments]);
		};
	});
}

export default Analytics;



// WEBPACK FOOTER //
// ../shared/Analytics.js